import { blue, grey, orange } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: "Galano Grotesque Alt",
    fontSize: 15,
    fontWeightRegular: 400,
    color: "#000",
    h6: {
      fontWeight: 500,
    },
    body: {
      fontSize: 16,
      fontFamily: "Galano Grotesque Alt",
    },
    body3: {
      fontSize: 12,
      lineHeight: 1,
      fontFamily: "Galano Grotesque Alt",
    },
    body4: {
      fontSize: 14,
      lineHeight: 1,
      fontFamily: "Galano Grotesque Alt",
    },
    propdethead: {
      fontSize: 24,
      fontWeight: 500,
      fontFamily: "Galano Grotesque Alt",
      lineHeight: 1,
    },
    H4_5: {
      fontSize: 24,
      fontWeight: 500,
    },
    tinyRegular: {
      fontSize: 12,
      fontWeight: 400,
    },
    tinyMedium: {
      fontSize: 12,
      fontWeight: 500,
    },
    small: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "20px",
    },
    smallMedium: {
      fontSize: 14,
      fontWeight: 500,
    },
    smallSemiBold: {
      fontSize: 14,
      fontWeight: 600,
    },
    smallBold: {
      fontSize: 14,
      fontWeight: 700,
    },
    regularMedium: {
      fontSize: 16,
      fontWeight: 500,
    },
    mediumMedium: {
      fontSize: 18,
      fontWeight: 500,
    },
    mediumSemiBold: {
      fontSize: 18,
      fontWeight: 600,
    },
    largeBold: {
      fontSize: 20,
      fontWeight: 700,
    },
    bodyRegular: {
      fontSize: 28,
      fontWeight: 400,
    },
  },
  palette: {
    primary: {
      main: "#FFAA01",
      magenta: {
        400: "#FF0A58",
        25: "#FFEFF4",
      },
      Gray: {
        200: "#58677D",
      },
      active: "#01783e",
    },
    secondary: {
      main: "#1378A5",
    },
    tertiary: {
      main: "#C7380B",
    },
    text: {
      main: "#000",
      orange: {
        1: "#7C380B",
      },
      blue: "#0B416F",
    },
    paper: {
      main: "#fff",
    },
    alternate: {
      main: "#054D87",
    },
    neutral: {
      main: "#AAA",
      dark: "#444444",
    },
    background: {
      default: "#EEEEEE",
      avatar: "#bdbdbd",
      alternate: {
        1: "#F0F8FF",
        2: "#07294A",
      },
    },
    button: {
      link: "#BB5902",
      star: "#F2B347",
      search: "#f49400",
    },
    border: {
      main: "#E9EAEB",
      lighter: "#CCC",
      lightest: "#EEE",
    },
    brand: {
      orange: {
        ...orange,
        50: "#FFFDEA",
      },
      blue: {
        ...blue,
        100: "#E0EFFE",
      },
      grey: {
        ...grey,
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
    // MuiCard: {
    //   styleOverrides: {
    //     root: {
    //       borderRadius: 12,
    //     },
    //   },
    // },
  },
  primaryColor: "#FFAA01",
  secondaryColor: "#1378A5",
});
